<template>
  <footer class="app-footer d-flex justify-content-between">
    <span class="copyright-text">&copy; Aduro, Inc. All rights reserved.</span>
    <span class="app-version">Version {{ appVersion }}. API {{ apiVersion }}</span>
    <span class="support-text"
      >We're here to help:
      <a target="_blank" href="https://support.adurolife.com/hc/en-us"
        >Contact Support</a
      ></span
    >
  </footer>
</template>
<script>
import { appVersion } from '../_consts.js';
import {
  GETTER_API_CURRENT_VERSION,
  ACTION_API_CURRENT_VERSION
} from '@/store/modules/common/constants';
import { mapGetters, mapActions } from "vuex";
export default {
  name: "bottom",
  data() {
    return {
      appVersion: appVersion
    };
  },
  computed: {
    apiVersion() {
      let version = this.getterApiVersion;
      return version ? version.appVersion : 'N/A';
    },
    getCurrentYear() {
      return new Date().getFullYear();
    },
    ...mapGetters({
      getterApiVersion: GETTER_API_CURRENT_VERSION
    })
  },
  methods: {
    ...mapActions({
      actionGetApiVersion: ACTION_API_CURRENT_VERSION
    })
  },
  beforeMount() {
    this.actionGetApiVersion();
  }
};
</script>
<style scoped>
.app-version {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue